const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let Counter, ContextConsumer, Intermediary, Interceptor, ClickCounter, Animation, CounterPage;
let { Component } = blop;


Counter = (attributes, _children, node) => {let increase, decrease;
  // copying the React weird hook interface
  let { value: counter, setState } = node.useState('counter', 0);
  increase = () =>setState(counter + 1);
  decrease = () =>setState(counter - 1);
  const __1c = []; const __1a = {};
    const __2c = []; const __2a = {}; const __3 = attributes.name; Array.isArray(__3) ? __2c.push(...__3) : __2c.push(__3); const __2 = blop.h('h4', __2a, __2c); __1c.push(__2);
    const __4c = []; const __4a = {};
      const __5c = []; const __5a = {}; __5a['class'] = 'btn btn-success'; __5a['on'] = ({ click: increase }); const __6 = 'increase'; Array.isArray(__6) ? __5c.push(...__6) : __5c.push(__6); const __5 = blop.h('button', __5a, __5c); __4c.push(__5);
      const __7c = []; const __7a = {}; __7a['class'] = 'btn btn-danger'; __7a['on'] = ({ click: decrease }); const __8 = 'decrease'; Array.isArray(__8) ? __7c.push(...__8) : __7c.push(__8); const __7 = blop.h('button', __7a, __7c); __4c.push(__7);
      const __9c = []; const __9a = {}; __9a['style'] = ({ 'font-size': '20px' }); const __10 = ` ${counter} `; Array.isArray(__10) ? __9c.push(...__10) : __9c.push(__10); const __9 = blop.h('b', __9a, __9c); __4c.push(__9);
     const __4 = blop.h('label', __4a, __4c); __1c.push(__4);
    // = children // warning: children will not be re-rendered with setState
   const __1 = blop.h('div', __1a, __1c); return __1;
};

ContextConsumer = (_attributes, _children, node) => {
  let { value } = node.useContext('specialNumber');
  const __11c = []; const __11a = {}; const __12 = value; Array.isArray(__12) ? __11c.push(...__12) : __11c.push(__12); const __11 = blop.h('p', __11a, __11c); return __11;
};

Intermediary = () =>(() => {const __13c = []; const __13a = {}; const __13 = blop.c(ContextConsumer, __13a, __13c, '__13'); return __13;})();
Interceptor = (_attributes, _children, node) => {
  node.useContext('specialNumber', 'specialNumber intercepted');
  const __14c = []; const __14a = {}; const __14 = blop.c(ContextConsumer, __14a, __14c, '__14'); return __14;
};

function renderClickCounter(value) {
  const __15c = []; const __15a = {}; const __16 = value; Array.isArray(__16) ? __15c.push(...__16) : __15c.push(__16); const __15 = blop.h('p', __15a, __15c); return __15;
};

ClickCounter = (_attributes, _children, node) => {let increase;
  let { value: counter, setState, getState } = node.useState('counter', 0);
  increase = () => {
    // need to use getState here as counter value
    // gets captured in increase and never changes
    setState(getState() + 1);
  };
  node.mount((_vnode) => {
    console.log('mount ClickCounter');
    document.addEventListener('click', increase);
  });
  node.unmount((_vnode) => {
    document.removeEventListener('click', increase);
    console.log('unmount ClickCounter');
  });
  return renderClickCounter(counter)
};

function Window() {
  // a window object usable in SSR
  if (typeof window === 'undefined') {
    return ({ innerWidth: 960 })
  }
  return window
};


function useWindowWidth(node) {let w, handleResize;
  w = Window();
  let { value: width, setState: setWidth } = node.useState('width', w.innerWidth);
  handleResize = () =>setWidth(w.innerWidth);
  node.mount(() => {
    console.log('mount useWindowWidth');
    window.addEventListener('resize', handleResize);
  });
  node.unmount((_vnode) => {
    console.log('unmount useWindowWidth');
    window.removeEventListener('resize', handleResize);
  });
  return width
};

Animation = (attributes, children, node) => {let w, runAnimation, i, animate, __18;
  w = Window();
  let { value: position, setState: setPos } = node.useState('pos', ({ x: 0, y: 0 }));
  runAnimation = true;
  i = attributes.initial || 0;
  animate = () => {
    i += 0.02
    position.x = (w.innerWidth / 2) + 120 * Math.cos(i) - 60;
    position.y = (w.innerHeight / 2) + 120 * Math.sin(i) - 60;
    setPos(position);
    runAnimation && window.requestAnimationFrame(animate);
  };
  node.mount(() => {
    console.log('mount Animation');
    window.requestAnimationFrame(animate);
  });
  node.unmount((_vnode) => {
    console.log('unmount Animation');
    runAnimation = false;
  });
  const __17c = []; const __17a = {}; __17a['style'] = ({ left: `${position.x}px`, top: `${position.y}px`, position: 'absolute' });
    __18 = children; Array.isArray(__18) ? __17c.push(...__18) : __17c.push(__18); ;
   const __17 = blop.h('div', __17a, __17c); return __17;
};

class ComponentWithClass extends Component {
  render() {
    let { text } = this.attributes;
    const __19c = []; const __19a = {};
      const __20c = []; const __20a = {}; const __21 = `hello ${text}`; Array.isArray(__21) ? __20c.push(...__21) : __20c.push(__21); const __20 = blop.h('p', __20a, __20c); __19c.push(__20);
      const __22c = []; const __22a = {}; const __23 = JSON.stringify(this.pos); Array.isArray(__23) ? __22c.push(...__23) : __22c.push(__23); const __22 = blop.h('p', __22a, __22c); __19c.push(__22);
     const __19 = blop.h('div', __19a, __19c); return __19;
  }


  mouseMove(e) {
    this.pos = ({ x: e.x, y: e.y });
    this.refresh();
  }


  onMount() {
    this.mouseMoveHandler = (e) =>this.mouseMove(e);
    document.addEventListener('mousemove', this.mouseMoveHandler);
  }


  onUnmount() {
    document.removeEventListener('mousemove', this.mouseMoveHandler);
  }

 }

CounterPage = (_attributes, _children, node) => {let width, width2, changeValue;
  width = useWindowWidth(node);
  width2 = useWindowWidth(node) + 10;
  let { setContext } = node.useContext('specialNumber', Math.random());
  changeValue = () =>setContext(Math.random());
  const __24c = []; const __24a = {};
    const __25c = []; const __25a = {}; const __26 = 'ClassComponent'; Array.isArray(__26) ? __25c.push(...__26) : __25c.push(__26); const __25 = blop.h('h3', __25a, __25c); __24c.push(__25);
    const __27c = []; const __27a = {}; const __28 = 'Here is an example of a Class based Component'; Array.isArray(__28) ? __27c.push(...__28) : __27c.push(__28); const __27 = blop.h('p', __27a, __27c); __24c.push(__27);
    const __29c = []; const __29a = {}; __29a['text'] = 'world'; const __29 = blop.c(ComponentWithClass, __29a, __29c, '__29'); __24c.push(__29);
    const __30c = []; const __30a = {}; const __31 = 'useState'; Array.isArray(__31) ? __30c.push(...__31) : __30c.push(__31); const __30 = blop.h('h3', __30a, __30c); __24c.push(__30);
    const __32c = []; const __32a = {}; const __33 = `An example on how you can have state stored inside a component.
      Setting a state in a component will re-render this component.
      Reloading the page will reset the state.`; Array.isArray(__33) ? __32c.push(...__33) : __32c.push(__33); const __32 = blop.h('p', __32a, __32c); __24c.push(__32);
    const __34c = []; const __34a = {}; const __35 = 'Animation 0'; Array.isArray(__35) ? __34c.push(...__35) : __34c.push(__35); const __34 = blop.c(Animation, __34a, __34c, '__34'); __24c.push(__34);
    const __36c = []; const __36a = {}; __36a['initial'] = 1; const __37 = 'Animation 1'; Array.isArray(__37) ? __36c.push(...__37) : __36c.push(__37); const __36 = blop.c(Animation, __36a, __36c, '__36'); __24c.push(__36);
    const __38c = []; const __38a = {}; __38a['initial'] = 2; const __39 = 'Animation 2'; Array.isArray(__39) ? __38c.push(...__39) : __38c.push(__39); const __38 = blop.c(Animation, __38a, __38c, '__38'); __24c.push(__38);
    const __40c = []; const __40a = {}; __40a['initial'] = 3; const __41 = 'Animation 3'; Array.isArray(__41) ? __40c.push(...__41) : __40c.push(__41); const __40 = blop.c(Animation, __40a, __40c, '__40'); __24c.push(__40);
    const __42c = []; const __42a = {}; __42a['initial'] = 4; const __43 = 'Animation 4'; Array.isArray(__43) ? __42c.push(...__43) : __42c.push(__43); const __42 = blop.c(Animation, __42a, __42c, '__42'); __24c.push(__42);
    const __44c = []; const __44a = {}; __44a['initial'] = 5; const __45 = 'Animation 5'; Array.isArray(__45) ? __44c.push(...__45) : __44c.push(__45); const __44 = blop.c(Animation, __44a, __44c, '__44'); __24c.push(__44);
    const __46c = []; const __46a = {}; __46a['name'] = 'Counter 1'; const __46 = blop.c(Counter, __46a, __46c, '__46'); __24c.push(__46);
    const __47c = []; const __47a = {}; __47a['name'] = 'Counter 2'; const __47 = blop.c(Counter, __47a, __47c, '__47'); __24c.push(__47);

    const __48c = []; const __48a = {}; const __49 = 'useContext'; Array.isArray(__49) ? __48c.push(...__49) : __48c.push(__49); const __48 = blop.h('h3', __48a, __48c); __24c.push(__48);
    const __50c = []; const __50a = {}; const __51 = `useContext allow you to pass values down the tree 
      while still being segregated hierarchically.
      Changing context in a parent will automatically
      trigger re-render in the listening children.`; Array.isArray(__51) ? __50c.push(...__51) : __50c.push(__51); const __50 = blop.h('p', __50a, __50c); __24c.push(__50);
    const __52c = []; const __52a = {}; const __52 = blop.c(Intermediary, __52a, __52c, '__52'); __24c.push(__52);
    const __53c = []; const __53a = {}; const __53 = blop.c(Interceptor, __53a, __53c, '__53'); __24c.push(__53);
    const __54c = []; const __54a = {}; __54a['on'] = ({ click: changeValue }); const __55 = 'Change value of the context'; Array.isArray(__55) ? __54c.push(...__55) : __54c.push(__55); const __54 = blop.h('button', __54a, __54c); __24c.push(__54);
    const __56c = []; const __56a = {}; const __57 = 'lifecycle'; Array.isArray(__57) ? __56c.push(...__57) : __56c.push(__57); const __56 = blop.h('h3', __56a, __56c); __24c.push(__56);
    const __58c = []; const __58a = {}; const __59 = 'lifecycle gives you access to the snabbdom lifecycle hooks directly from a component.'; Array.isArray(__59) ? __58c.push(...__59) : __58c.push(__59); const __58 = blop.h('p', __58a, __58c); __24c.push(__58);
    const __60c = []; const __60a = {}; const __60 = blop.c(ClickCounter, __60a, __60c, '__60'); __24c.push(__60);
    const __61c = []; const __61a = {}; const __62 = 'Famous React hook useWindowWidth'; Array.isArray(__62) ? __61c.push(...__62) : __61c.push(__62); const __61 = blop.h('h3', __61a, __61c); __24c.push(__61);
    const __63c = []; const __63a = {}; const __64 = `useWindowWidth:${width}`; Array.isArray(__64) ? __63c.push(...__64) : __63c.push(__64); const __63 = blop.h('p', __63a, __63c); __24c.push(__63);
    const __65c = []; const __65a = {}; const __66 = `useWindowWidth+10:${width2}`; Array.isArray(__66) ? __65c.push(...__66) : __65c.push(__66); const __65 = blop.h('p', __65a, __65c); __24c.push(__65);
   const __24 = blop.h('div', __24a, __24c); return __24;
};


module.exports = { Component, Counter, ContextConsumer, Intermediary, Interceptor, renderClickCounter, ClickCounter, Window, useWindowWidth, Animation, ComponentWithClass, CounterPage };
